import { z } from 'zod';

const nullToUndefined = z
  .string()
  .nullish()
  .transform((v) => v ?? undefined);

export const suggestNextVersionsResponseSchema = z.object({
  nextMajor: z.string().default(''),
  nextMinor: nullToUndefined,
});

export const promoteAppVersionFromDraftResponseSchema = z.object({
  appVersion: z.object({
    fullVersion: z.string().nullish(),
  }),
});

export const getLatestProductionVersionResponseSchema = z.object({
  appVersion: z
    .object({
      version: z.number(),
    })
    .optional(),
});

// Shared by createComponentsOverride and updateOverrideWithNoSideEffects —
// both responses carry just the override id.
export const overrideIdResponseSchema = z.object({
  componentsOverride: z.object({
    id: z.string(),
  }),
});
